<div class="tw-relative tw-min-h-[500px] tw-w-full tw-py-12 md:tw-py-24">
  <!-- Imagen de fondo con filtros mejorados -->
  <div
    class="tw-absolute tw-inset-0 tw-bg-cover tw-bg-center"
    style="
      background-image: url('assets/images/background.png');
      opacity: 0.9;
      mix-blend-mode: soft-light;
      filter: sepia(30%) saturate(500%) hue-rotate(175deg) brightness(85%)
        contrast(95%);
    "
  ></div>

  <!-- Contenido centrado con espaciado uniforme -->
  <div class="tw-relative tw-z-10 tw-container tw-mx-auto tw-px-6 tw-h-full">
    <div class="tw-flex tw-items-center tw-justify-center tw-h-full">
      <div
        class="tw-grid tw-grid-cols-1 lg:tw-grid-cols-2 tw-gap-12 tw-items-center tw-w-full tw-py-8"
      >
        <!-- Columna izquierda -->
        <div class="tw-text-center lg:tw-text-left tw-animate-fade-in">
          <h4
            class="tw-text-white tw-text-3xl md:tw-text-5xl tw-font-bold tw-mb-6 tw-leading-tight"
          >
            Conecta con <span class="tw-text-orange-400">OneLink</span> hoy
            mismo
          </h4>
          <p
            class="tw-text-gray-200 tw-text-lg md:tw-text-xl tw-max-w-2xl tw-mx-auto lg:tw-mx-0 tw-mb-8"
          >
            Nuestro equipo está listo para ayudarte a llevar tu negocio al
            siguiente nivel.
          </p>
          <div
            class="tw-flex tw-flex-wrap tw-gap-4 tw-justify-center lg:tw-justify-start"
          >
            <div
              class="tw-flex tw-items-center tw-text-white tw-bg-white/10 tw-px-4 tw-py-3 tw-rounded-lg tw-border tw-border-white/10"
            >
              <span class="tw-mr-3 tw-text-2xl">📱</span>
              <span class="tw-font-medium">+58 281 3169200</span>
            </div>
            <div
              class="tw-flex tw-items-center tw-text-white tw-bg-white/10 tw-px-4 tw-py-3 tw-rounded-lg tw-border tw-border-white/10"
            >
              <span class="tw-mr-3 tw-text-2xl">📧</span>
              <span class="tw-font-medium">infotecnosystem.io</span>
            </div>
          </div>
        </div>

        <!-- Columna derecha (formulario) -->
        <div
          class="tw-bg-white/5 tw-backdrop-blur-md tw-rounded-2xl tw-p-8 tw-border tw-border-white/10 tw-shadow-xl tw-max-w-lg tw-mx-auto  tw-animate-slide-up"
        >
          <h5
            class="tw-text-orange-400 tw-text-2xl tw-font-bold tw-mb-6 tw-text-center"
          >
            ¿En qué podemos ayudarte?
          </h5>
          <div class="tw-space-y-4">
            <button
              class="tw-w-full tw-bg-orange-500 hover:tw-bg-orange-600 tw-text-white tw-font-semibold tw-py-3 tw-px-6 tw-rounded-lg tw-transition-all tw-duration-300 tw-flex tw-items-center tw-justify-center"
            >
              <span class="tw-mr-2">💬</span> Chat en vivo
            </button>

            <button
              class="tw-w-full tw-bg-transparent hover:tw-bg-white/10 tw-text-white tw-font-semibold tw-py-3 tw-px-6 tw-rounded-lg tw-border tw-border-orange-500 tw-transition-all tw-duration-300 tw-flex tw-items-center tw-justify-center"
            >
              <span class="tw-mr-2">📞</span> Llamada inmediata
            </button>

            <button
              class="tw-w-full tw-bg-transparent hover:tw-bg-white/10 tw-text-white tw-font-semibold tw-py-3 tw-px-6 tw-rounded-lg tw-border tw-border-white/30 tw-transition-all tw-duration-300 tw-flex tw-items-center tw-justify-center"
            >
              <span class="tw-mr-2">✉️</span> Enviar mensaje
            </button>
          </div>

          <div
            class="tw-mt-6 tw-pt-4 tw-border-t tw-border-white/10 tw-text-center"
          >
            <p class="tw-text-gray-300 tw-text-sm">
              También puedes visitarnos en:<br />
              <span class="tw-text-white tw-font-medium"
                >Centro Comercial Galenos Center, piso 2, local C-8</span
              >
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
